import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { environment } from '../../app/../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApplicationInsightsService {
  constructor() {
    const config = environment.applicationInsights;
    if (config?.enabled && config?.connectionString) {
      const appInsights = new ApplicationInsights({
        config: {
          connectionString: config.connectionString,
          enableAutoRouteTracking: true,
          enableUnhandledPromiseRejectionTracking: true,
        },
      });

      appInsights.loadAppInsights();
      appInsights.context.application.ver = environment.version;

      // Set cloud role name ("ESS-{Environment}")
      if (config.cloudRoleName) {
        const cloudRoleName = `${config.cloudRoleName}-${environment.env}`;
        // roleInstance: In PayrollSite uses System.Environment.MachineName
        // for Angular - In browser environment, we use hostname as equivalent (identifies the server/domain)
        const roleInstance = typeof window !== 'undefined' ? window.location.hostname : 'unknown';
        const prefix = 'ai';

        appInsights.addTelemetryInitializer(envelope => {
          if (envelope.tags) {
            envelope.tags[`${prefix}.cloud.role`] = cloudRoleName;
            envelope.tags[`${prefix}.cloud.roleInstance`] = roleInstance;
          }
        });
      }
    }
  }
}
